import { render, staticRenderFns } from "./MailHistoryTable.vue?vue&type=template&id=67e662d8&scoped=true"
import script from "./MailHistoryTable.vue?vue&type=script&lang=ts"
export * from "./MailHistoryTable.vue?vue&type=script&lang=ts"
import style0 from "./MailHistoryTable.vue?vue&type=style&index=0&id=67e662d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e662d8",
  null
  
)

export default component.exports